import { useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";


export const AddWheelModel = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [modelName, setModelName] = useState<string>("");
    const [wheelType, setWheelType] = useState<string>("");
    const [brandId, setBrandId] = useState<number>(0);
    const [brands, setBrands] = useState<any[]>([]);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        axios.get(`${baseURL}wheelBrands`)
            .then((response) => {
                setBrands(response?.data?.map((item: any) => {
                    return { value: item.brandId, label: item.brandName }
                }))
                setBrandId(response?.data[0]?.brandId || 0)
            }).catch(error => {
                setBrandId(0);
                setBrands([]);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await axios
            .post(
                `${baseURL}wheelModels?userId=${auth?.id}`,
                JSON.stringify({
                    modelName,
                    brandId,
                    wheelType
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Model</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Model Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={modelName}
                                                placeholder="Model Name"
                                                onChange={(e) => setModelName(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Wheel Type</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={wheelType}
                                                placeholder="Wheel Type"
                                                onChange={(e) => setWheelType(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Brand</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={brandId}
                                                onChange={(e) => setBrandId(Number(e.target.value))}
                                                required
                                            >
                                                {brands?.map((brand: any) => (
                                                    <option key={brand.value} value={brand.value}>
                                                        {brand.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}